module.exports = __webpack_public_path__ + "img/der_01_scan.37c34f29.svg";